import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthenticationService } from '@modules/authentication';
import { OctopusConnectService } from 'octopus-connect';
import { take, catchError, map } from 'rxjs/operators';
import {UserDataAttributesInterface} from "@modules/authentication/core/models/user-data-entity.type";

@Injectable({ providedIn: 'root' })
export class TokenOrLoggedGuard implements CanActivate {
    private authenticationService = inject(AuthenticationService);
    private connector = inject(OctopusConnectService);
    private router = inject(Router);

    canActivate(
        route: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> {
        const token = route.queryParamMap.get('token') || route.paramMap.get('token');
        if (token) {
            // Authentification via token
            this.authenticationService.setTokenData(token);
            return this.connector.authenticated<UserDataAttributesInterface>('http').pipe(
                take(1),
                map(user => {
                    this.authenticationService.onAuthenticated(user);
                    return true;
                }),
                catchError(() => {
                    this.authenticationService.goToLogin();
                    return of(false);
                })
            );
        } else {
            // Vérification utilisateur déjà authentifié
            if (this.authenticationService.isAuthenticated) {
                return of(this.authenticationService.isAuthenticated);
            }
            this.authenticationService.goToLogin();
            return of(false);
        }
    }
}
